import Navbar from "../../Components/NavBar/index";
import Footer from "../../Components/Footer/index";
import SEO from "../../Components/SEO/index";
import BlogComponent from "../../Components/Blog/index";
import Body7 from "../../Components/Home-new/Body7";
import Body9 from "../../Components/Home-new/Body9";
import { BlogDataProvider, useBlogData } from "../../database/BlogDataContext";
import { BlogSkeleton, Body7Skeleton, Body9Skeleton } from "../../Components/Skeletons/Skeletons";

const BlogPageContent = () => {
    const { data, isLoading } = useBlogData();

    if (isLoading) {
        return (
            <>
                <BlogSkeleton />
                <Body7Skeleton />
                <Body9Skeleton />
            </>
        );
    }

    return (
        <>
            <div >
                <BlogComponent preloadedData={data.blog} />
            </div>
            <Body7 preloadedData={data.body7} />
            <Body9 preloadedData={data.body9} />
        </>
    );
};

const BlogPage = () => {
    return (
        <BlogDataProvider>
            <SEO pageName="blog" />
            <Navbar />
            <BlogPageContent />
            <Footer />
        </BlogDataProvider>
    );
};

export default BlogPage;
